<template>
  <div class="form-container">
        <h2>Get in touch</h2>
        <p>Contact us to book a private demonstration or to find out more. Please read our <a tabindex="20" href="https://www.rarerecruitment.co.uk/privacy-policy" target="_blank">privacy policy</a>.</p>
    <form id="rare-contact-form">
      <!-- Hubspot form goes here -->
    </form>

    <!-- THANKS MODAL -->
    <div v-if="signUpSuccessful" id="thanksModal">
      <div id="thanksInner">
        <rare-modal-close-icon-large
          class="rareModalCloseIcon"
          @clicked="closeThankYouModal"
        />

        <h2>Thank you</h2>
        <p>Your request has been sent and we'll be in touch shortly.</p>

        <div style="margin: 0 auto; ">
        <rare-standard-button
          :active="'true'"
          :width="'200px'"
          :height="'40px'"
          :fontSize="'14px'"
          :buttonText="'Close'"
          @clicked="closeThankYouModal"
        />
        </div>
      </div>
  </div>
  </div>
</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';

export default {
  name: 'RareContactForm',
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
  },
  props: {
    product: '',
    id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hubSpotFormIDMap: {
        Vantage: '46d189c9-e472-4f7f-99a8-177674c7c4e5',
        Hemisphere: '129a5523-c7b4-4fc7-9828-e830a3d3fde6',
        CRS: '2a4a5528-5685-4c21-80d0-c7bd7a139031',
        'Candid ATS': '4389bc88-8462-4772-9466-a401350249ba',
        'Attraction & Development': 'd6d77187-39c4-44fb-8795-8a4ef4ffdb32',
      },
      contactFormData: {
        hubSpotID: '',
        IDString: '',
      },
      signUpSuccessful: false,
    };
  },
  mounted() {
    this.contactFormData.product = this.product;
    this.contactFormData.IDString = this.processProductID(this.product);
    this.contactFormData.hubSpotID = this.hubSpotFormIDMap[this.product];

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '27067983',
          formId: this.contactFormData.hubSpotID,
          target: '#rare-contact-form',
          onFormSubmitted: () => {
            if (this.product === 'Candid ATS') {
              window.lintrk('track', { conversion_id: 15462994 });
            }
            this.openThankYouModal();
          },
        });
      }
    });
  },
  methods: {
    processProductID(id) {
      let processedProduct = `${id[0].toUpperCase()}${id.slice(1)}`;
      processedProduct = processedProduct.replace(/&/g, '');
      processedProduct = processedProduct.replace(/\s/g, '');
      return processedProduct;
    },
    openThankYouModal() {
      this.signUpSuccessful = true;
    },
    closeThankYouModal() {
      this.signUpSuccessful = false;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

#thanksModal:focus, #thanksModal:active {
  outline: none;
}

.form-container {
  background-color: #f5f5f5;
  border-top: 2px solid white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
}

h2 {
  font-family: 'Europa';
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: $main-text;
}

p {
  font-family: 'Europa';
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: $main-text;
}

a {
  color: $main-text;
}

.button-row {
  display: flex;
  justify-content: center;
}

label, .successMessage {
  font-family: 'Europa';
  font-style: normal;
  font-weight: 700;
  color: $main-text;
}

.sub-label {
  font-family: 'Europa';
  font-style: normal;
  font-weight: 400;
  color: $main-text;
}

input, select {
  background: #FFFFFF;
  border: 1px solid $border;
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  color: $light-grey-text;
}

select {
  background-image: url("../../assets/img/icons/down-chev.png");
  background-repeat: no-repeat;
  background-position: 95% center;
}

.validationFail {
  border-color: red;
  background-color: #ffeeee;
  color: #bc0000;
}

@media only screen and (max-width: 640px)  {
  h2 {
    font-size: 50px;
    line-height: 50px;
    margin: 50px 0 32px 0 ;
  }

  p {
    width: 360px;
    font-size: 18px;
    line-height: 28px;
  }

  .form-row {
    width: 360px;
    margin: 23px 0 0 0;
  }

  .button-row {
    width: 360px;
    margin: 35px 0 50px 0;
  }

  label, .successMessage {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  .sub-label {
    display: block;
    font-size: 16px;
    line-height: 28px;
  }

  input, select {
    height: 55px;
    border-radius: 30px;
    margin-bottom: 0;
    padding-left: 22px;
    font-size: 18px;
    line-height: 35px;
  }
}

@media only screen and (min-width: 641px)  {
  h2 {
    font-size: 64px;
    line-height: 76px;
    margin: 50px 0 10px 0 ;
  }

  p {
    width: 682px;
    font-size: 24px;
    line-height: 35px;
    margin-bottom: 40px;
  }

  .form-row {
    width: 580px;
    margin: 26px 0 0 0;
  }

  .button-row {
    width: 580px;
    margin: 50px 0 80px 0;
  }

  label, .successMessage {
    font-size: 24px;
    line-height: 35px;
    margin-bottom: 10px;
  }

  .sub-label {
    font-size: 20px;
    line-height: 35px;
  }

  input, select {
    height: 70px;
    border-radius: 35px;
    margin-bottom: 0;
    padding-left: 27px;
    font-size: 24px;
    line-height: 35px;
  }
}

#thanksModal {
  display: flex;
  position: fixed;
  z-index: 99999;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-content: center;
  align-items: center;
}

#thanksInner {
  position: relative;
  width: 800px;
  height: 350px;
  background-color: white;
  text-align: left;
  padding: 0 70px 0 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.rareModalCloseIcon {
  position: absolute;
  cursor: pointer;
  right: 0%;
  top: 0%;
  margin-top: 10px;
  margin-right: 20px;
}

#thanksInner h2 {
  font-size: 32px;
  font-weight: normal;
  margin: 10px 0 30px 0 !important;
}

#thanksInner p {
  font-size: 24px;
}

@media only screen and (max-width: 640px) {

  #thanksInner {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: white;
    text-align: left;
    padding: 0 20px 0 20px;
  }

  .rareModalCloseIcon {
    margin-top: 65px;
    margin-right: 20px;
  }

  #thanksInner p {
    text-align: center;
    width: 100%;
    padding: 0 40px;
    margin-bottom: 40px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/forms/RareContactForm.vue